import { render, staticRenderFns } from "./vipFixButton.vue?vue&type=template&id=8be6e7ca&scoped=true&"
import script from "./vipFixButton.vue?vue&type=script&lang=ts&"
export * from "./vipFixButton.vue?vue&type=script&lang=ts&"
import style0 from "./vipFixButton.vue?vue&type=style&index=0&id=8be6e7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be6e7ca",
  null
  
)

export default component.exports